import { IconButton, SearchInput, Select } from "@alm/flow-ds/components";
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";

import PageHeader from "components/PageHeader";
import addSentryBreadcrumb from "sentry/addSentryBreadcrumb";

interface Props {
	onChangeSearchValue: (value: string) => void;
}

const TasksAdminViewHeader = ({ onChangeSearchValue }: Props) => {
	const { t } = useTranslation();

	const history = useHistory();
	const location = useLocation();

	const [mobileOpen, setMobileOpen] = useState(false);

	const [searchBox, setSearchBox] = useState("");

	const handleSearchChange = useCallback(
		(event: React.ChangeEvent<HTMLInputElement>) => {
			const value = event.currentTarget.value;
			addSentryBreadcrumb({
				category: "input.change",
				message: `Search input valued changed to "${value}"`,
			});
			if (value !== "") {
				setSearchBox(value);
			} else {
				setSearchBox(value);
				onChangeSearchValue(value);
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[]
	);

	const handleSelectChange = useCallback(
		(e: React.ChangeEvent<HTMLSelectElement>) => {
			const value = e.currentTarget.value;
			addSentryBreadcrumb({
				category: "input.change",
				message: `Select value changed to "${value}"`,
			});

			history.push(value);
			if (searchBox !== "") setSearchBox("");
		},
		[history, searchBox]
	);

	return (
		<div className="tasks__header-container">
			<PageHeader
				title={t("main.tasks.headings.pageTitle")}
				className="page-header__tasks">
				<div
					className="search-bar search-bar--icon"
					aria-expanded={mobileOpen}>
					<IconButton
						aria-label={t("main.icons.openSearchBox")}
						active={mobileOpen}
						className="btn-basic--primary btn--round"
						icon="search"
						onClick={() => setMobileOpen(!mobileOpen)}
					/>
				</div>
			</PageHeader>
			<div className="tasks__filters-container">
				{mobileOpen && (
					<div className="search-bar--mobile">
						<SearchInput
							label={t("main.text.search")}
							onSearch={() => onChangeSearchValue(searchBox)}
							onChange={handleSearchChange}
							value={searchBox}
						/>
					</div>
				)}
				<Select
					className="mb-0 tasks__select"
					value={location.pathname}
					onChange={handleSelectChange}
					label={t("main.tasks.labels.typeOfTasks")}
					labelHidden>
					<>
						<option value="/admin/tasks">
							{t("main.tasks.headings.allTasks")}
						</option>
						<option value="/admin/tasks/active">
							{t("main.tasks.headings.active")}
						</option>
						<option value="/admin/tasks/completed">
							{t("main.tasks.headings.completed")}
						</option>
					</>
				</Select>

				<div className="search-bar search-bar--desktop ms-15">
					<SearchInput
						label={t("main.text.search")}
						onSearch={() => onChangeSearchValue(searchBox)}
						onChange={handleSearchChange}
						value={searchBox}
						className="mb-0 "
					/>
				</div>
			</div>
		</div>
	);
};

export default TasksAdminViewHeader;
